module.exports = {"attributes":{"width":"6px","height":"11px","viewBox":"0 0 6 11","version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"},"content":"<g>     <path d=\"M3,8.22148696 C2.80070066,8.22148696 2.60140132,8.14519268 2.44959128,7.99338264 L-2.22148696,3.3223044 L-1.12066952,2.22148696 L3,6.34215648 L7.12066952,2.22148696 L8.22148696,3.3223044 L3.55040872,7.99338264 C3.39859868,8.14519268 3.19929934,8.22148696 3,8.22148696\"></path>   </g>"}


//////////////////
// WEBPACK FOOTER
// ./client/components/Icon/images/chevron.svg
// module id = 1385
// module chunks = 0